import { observer } from 'mobx-react'

import { CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { LogicalTypes } from '@new/domains/operations/screens/CasesV2/CasesV2.types'
import { casesFiltersStore } from '@new/domains/operations/screens/CasesV2/stores/CasesFiltersStore'
import {
  CaseColumnNames,
  CaseFilterIds,
} from '@new/domains/operations/screens/CasesV2/utils/config'

import { CheckBoxOption, CheckBoxWrapper } from './commonFilterStyles.style'

const _AiGeneratedFilter = () => {
  const { setFilterValue, aiGenerated } = casesFiltersStore

  const handleDataFilter = (value?: string[] | undefined) => {
    setFilterValue(CaseFilterIds.AiGenerated, value)
  }

  const options = [
    {
      value: LogicalTypes.yes,
      label: <CheckBoxOption>Yes</CheckBoxOption>,
      hasFullWidth: true,
    },
    {
      value: LogicalTypes.no,
      label: <CheckBoxOption>No</CheckBoxOption>,
      hasFullWidth: true,
    },
  ]

  return (
    <CheckBoxWrapper>
      <CheckboxBasedFilter
        title={CaseColumnNames.AiGenerated}
        options={options}
        initialValue={aiGenerated}
        onChange={handleDataFilter}
      />
    </CheckBoxWrapper>
  )
}

export const AiGeneratedFilter = observer(_AiGeneratedFilter)
